<div class="container">
  <h3>
    Change Password
  </h3>
  <hr />
  <form class="form-horizontal" [formGroup]="changePasswordForm" (ngSubmit)="changePassword(changePasswordForm.value)">
    <div *ngIf="Message" class="row message"  [ngClass]="{'label-success':!Error,'label-danger':Error}">
      {{Message}}
    </div>
    <div class="row">
      <div class="form-group">
        <div class="col-lg-3"><label>Current Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="currentPassword" name="currentPassword" />
          <em *ngIf="changePasswordForm.controls.currentPassword.errors&&changePasswordForm.controls.currentPassword.errors['required'] && changePasswordForm.controls.currentPassword.touched" class="text-danger">Required!</em>
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3"><label>New Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="password" name="password" />
          <em *ngIf="changePasswordForm.controls.password.errors&&changePasswordForm.controls.password.errors['required'] && changePasswordForm.controls.password.touched" class="text-danger">Required!</em>
          <em *ngIf="changePasswordForm.controls.password.errors&&changePasswordForm.controls.password.errors['pattern']" class="text-danger">The password must contain uppercase, lowercase, numeric, one of [ #$^+=!*()@%&)] , and be at least 8 characters!</em>
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3"><label>Confirm Password</label></div>
        <div class="col-lg-9">
          <input type="password" class="form-group" formControlName="confirmPassword" name="confirmPassword" />
          <em *ngIf="!isMatch() && changePasswordForm.controls.confirmPassword.touched" class="text-danger">The password doesn't match!</em>
        </div>
      </div>
      <div class="form-group">
        <div class="col-lg-3">
        </div>
        <div class="col-lg-9 no-left-padding">
          <input type="submit" value="Submit" class="btn btn-success" [disabled]="!IsValid()" />
        </div>
      </div>
    </div>
  </form>
</div>
